// extracted by mini-css-extract-plugin
export default {"organisationSelect":"organisation-select__organisationSelect"};